import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TImpersonation } from './types-impersonation';

const initialState: TImpersonation = {
  impersonatedUser: '',
  isImpersonating: false,
  loggedUser: '',
};

const impersonationDuck = createSlice({
  name: 'impersonation',
  initialState,
  reducers: {
    impersonateUser: (state, action: PayloadAction<string>) => ({
      ...state,
      impersonatedUser: action.payload,
      isImpersonating: true,
    }),
    viewAsUser: (state, action: PayloadAction<string>) => ({
      ...state,
      impersonatedUser: action.payload,
      isImpersonating: false,
    }),
    setLoggedUser: (state, action: PayloadAction<string>) => ({
      ...state,
      loggedUser: action.payload,
      isImpersonating: false,
    }),
    endImpersonation: (state) => ({
      ...state,
      impersonatedUser: '',
      isImpersonating: false,
    }),
  },
});

export const { endImpersonation, impersonateUser, viewAsUser, setLoggedUser } = impersonationDuck.actions;
export default impersonationDuck.reducer;
